import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBInput, MDBRow } from 'mdbreact';
import React from 'react';
import { Link as RouterLink, Redirect } from 'react-router-dom';
import vi_logo from '../../Assets/visaero_logo.png';
import vd_logo from '../../Assets/visadone_logo.png';
import styles from './EnterNewPassword.module.css';
import sha256 from 'sha256';
import axios from '../../authAxios'
import TextField from '@material-ui/core/TextField';
const brand_color = localStorage.getItem('brand_color')
export class EnterNewPassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color : "",
            hidden: true,
            password: '',
            user_id: '',
            mobile_no: '',
            country_code: '',
            isLogin: false,
            token: '',
            isError: false,
            password_error_text: '',
            logo: '',
            host_name: 'VisaDone',
            error:false,
            errorMsg : "",
            success : false,
            successMsg : ""
        }
    }

    componentDidMount() {
       this.setState({brand_color : localStorage.getItem("brand_color")})
        const host = localStorage.getItem('host');
        if (host == "visaero") {
            this.setState({ logo: vi_logo })
            this.setState({ host_name: 'Visaero' })
        } else if (host == "visadone") {
            this.setState({ logo: vd_logo })
            this.setState({ host_name: 'VisaDone' })
        }
        this.setState({
            user_id: localStorage.getItem("user_id"),
            mobile_no: localStorage.getItem("mobile_no"),
            country_code: localStorage.getItem("country_code"),
            token: localStorage.getItem("token"),
        });
    }

    toggleShow = () => {
        this.setState({ hidden: !this.state.hidden });
    }

    handlePassword = (e) => {
        // console.log(e.target.value)
        //this.setState({password: sha256(e.target.value)})
        this.setState({ password: e.target.value })
        this.setState({
            isError: false,
            password_error_text: ""
        })
    }
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // console.log('enter press here! ')
            this.handleLoginBtnClick(event)
        }
    }
    handleLoginBtnClick = e => {
        // console.log(this.state.password.length)
        var pattern = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,20}$/);
        if (!pattern.test(this.state.password)) {
            //alert("Invalid password pattern")
            this.setState({
                isError: true,
                password_error_text: "The password must be at least 6 characters long and it must contain atleast one capital case character, atleast one small case character, atleast one number and atleast punctuation"
            })

        } else {
            this.setState({
                isError: false,
                password_error_text: ""
            })
            this.api_setNewPassword()
        }
    }

    api_setNewPassword = e => {
        // console.log("Continue Clicked ....")
        var convertedPassword = this.state.password
        // console.log(this.state.token)
        convertedPassword = sha256(convertedPassword)
        axios
            .post('/users/setPassword', {
                "_id": this.state.user_id,
                "new_password": convertedPassword,
                "platform": "web",
                "token": this.state.token
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {
                    if (resp.data.error_code === "1007") {
                        // alert(resp.data.msg)
                        this.setState({error : true , errorMsg :resp.data.msg , success : false})
                    } else {
                        // alert(resp.data.msg)
                        this.setState({error : true , errorMsg :resp.data.msg , success : false})

                    }
                } else {
                    // alert(resp.data.msg)
                    this.setState({success : true , successMsg : resp.data.msg , error : false})
                    localStorage.setItem('session_id', resp.data.session_id)
                    this.setState({ isLogin: true })
                }
            }).catch((err)=>{
                console.log(err);
            })

    }

    render() {
        if (this.state.isLogin) {
            return <Redirect to="/new-visa" />
        }
        return (
            <MDBCard size="sm" >
                <MDBCardBody >
                    <div className="text-center">
                        <img  src={this.state.logo} className={localStorage.getItem("host") == "visadone" ? "visadone_logo" : "visaero_logo"  +" img-fluid"}></img>
                    </div>
                    <div className="text-left mt-4">
                        <h3><b>Hello !</b></h3>
                    </div>
                    <div className="text-left">
                        <h5>Welcome to {this.state.host_name}</h5>
                    </div>
                    <div className="text-left" style={{ marginTop: '40%' }}>
                        {/* <MDBInput type="password" type={this.state.hidden ? 'password' : 'text'} label="Set Password" onChange={this.handlePassword} >
                            <i onClick={this.toggleShow} id="icon" style={{position:'absolute', bottom:'10%',right:'1%'}} className="fa fa-fw fa-eye" />
                        </MDBInput> */}
                        <MDBRow>
                            <MDBCol>
                                <TextField
                                    type={this.state.hidden ? 'password' : 'text'}
                                    style={{ width: '100%' }}
                                    error={this.state.isError}
                                    id="standard-error-helper-text"
                                    label="Set password"
                                    defaultValue=""
                                    value={this.state.password}
                                    onChange={this.handlePassword}
                                    helperText={this.state.password_error_text}
                                    autoComplete={false}
                                    onKeyPress={this.handleKeyPress}
                                />
                                    {this.state.hidden ?
                                 <i onClick={this.toggleShow} id="icon" style={{ position: 'absolute', bottom: '15%',cursor : "pointer" , right: '3%' }} className="fa fa-fw fa-eye-slash" />
                                  :
                                 <i onClick={this.toggleShow} id="icon" style={{ position: 'absolute', bottom: '15%',cursor : "pointer" , right: '3%' }} className="fa fa-fw fa-eye" />
                                    }
                            </MDBCol> </MDBRow>
                    </div>
                    <div className="mb-2 mt-4">
                        <MDBBtn id={styles.logoutBtn} style={{ backgroundColor: this.state.brand_color }} color="none" onClick={this.handleLoginBtnClick}>Continue</MDBBtn>
                    </div>
                    {this.state.error && 
                    <MDBAlert color="danger">{this.state.errorMsg}</MDBAlert>
                    }
                    {this.state.success &&
                    <MDBAlert color="success">{this.state.successMsg}</MDBAlert>
                    }
                </MDBCardBody>
            </MDBCard>
        );
    }
};

export default EnterNewPassword;